/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OrderLineRevisionSource = 0 | 1 | 2 | 3;

export const OrderLineRevisionSource = {
    UNSET: 0 as OrderLineRevisionSource,
    BACKOFFICE: 1 as OrderLineRevisionSource,
    CUSTOMER: 2 as OrderLineRevisionSource,
    PASSEPARTOUT_SELF_SERVICE: 3 as OrderLineRevisionSource
};

